var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"Detalle de estiba"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('stowage-detail-card',{attrs:{"stowage-id":_vm.stowageId}})],1)],1)],1),_c('stowage-boxes',{attrs:{"stowage-id":_vm.stowageId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }